<template>
  <div class="home">
    <the-hero :cover="cover" :link="link"></the-hero>

    <div class="section company">
      <section-title>{{ $t('firstTitle.text') }}</section-title>

      <carousel :perPage="1">
        <slide v-for="item in $t('companyInfo')" :key="$t('companyInfo').indexOf(item)">
          <company-card :info="item"></company-card>
        </slide>
      </carousel>
    </div>

    <the-blockquote :cover="cover">{{ $t('firstQuote') }}</the-blockquote>

    <div class="section personal">
      <section-title :sub="$t('secondTitle.sub')">{{ $t('secondTitle.text') }}</section-title>

      <carousel :perPage="3">
        <slide v-for="person in personal" class="center-text" :key="personal.indexOf(person)">
          <employee-card :person="person"></employee-card>
        </slide>
      </carousel>
    </div>

    <div class="section services">
      <section-title>{{ $t('thirdTitle.text') }}</section-title>
      <service-container></service-container>
    </div>

    <div class="section allies">
      <section-title :sub="$t('fourthTitle.sub')">{{ $t('fourthTitle.text') }}</section-title>
      <allied-card v-for="allied in allies" :key="allies.indexOf(allied)" :info="allied">
        Lorem ipsum, dolor sit amet consectetur adipisicing elit.
        Accusantium fugiat harum quas ipsum autem assumenda molestiae iste quidem,
        illo laboriosam voluptas cupiditate reprehenderit labore eaque necessitatibus molestias.
      </allied-card>
    </div>

    <the-blockquote :cover="cover">{{ $t('secondQuote') }}</the-blockquote>

    <div class="section contact">
      <section-title :sub="$t('fifthTitle.sub')">{{ $t('fifthTitle.text') }}</section-title>

      <div class="contact-map">
        <map-view></map-view>
        <office-container></office-container>
      </div>
    </div>

    <the-footer></the-footer>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

import TheHero from '@/components/TheHero.vue';
import SectionTitle from '@/components/SectionTitle.vue';
import CompanyCard from '@/components/CardCompany.vue';
import EmployeeCard from '@/components/CardEmployee.vue';
import ServiceContainer from '@/components/ServiceContainer.vue';
import OfficeContainer from '@/components/OfficeContainer.vue';
import AlliedCard from '@/components/CardAllied.vue';
import MapView from '@/components/TheMap.vue';
import TheBlockquote from '@/components/TheBlockquote.vue';
import TheFooter from '@/components/TheFooter.vue';

import Cover from '@/assets/images/cover.jpg';
import Edwin from '@/assets/images/tete/edwin.jpg';
import Tayra from '@/assets/images/tete/tayra.jpg';
import Ana from '@/assets/images/tete/ana.jpg';
import Alejandro from '@/assets/images/tete/alejandro.jpg';
import Arelys from '@/assets/images/tete/arelys.jpg';
import Gabriela from '@/assets/images/tete/gabriela.jpg';
import Claudio from '@/assets/images/tete/claudio.jpg';
import Brand from '@/assets/images/paolini.png';

export default {
  name: 'home',
  components: {
    MapView,
    Carousel,
    Slide,
    TheHero,
    SectionTitle,
    CompanyCard,
    EmployeeCard,
    ServiceContainer,
    AlliedCard,
    OfficeContainer,
    TheBlockquote,
    TheFooter,
  },
  data() {
    return {
      cover: Cover,
      link: 'info@bgsestudiojuridico.com',
      personal: [
        {
          id: 'tbarsallo',
          image: Tayra,
          name: 'Tayra Barsallo',
          title: 'Master en Comercio Internacional / Derecho Migratorio',
          position: 'Socio Adjunto',
          linkedin: 'https://www.linkedin.com/in/tayra-ivonne-barsallo-94ab8814/',
          mail: 'tbarsallo@bgsestudiojuridico.com',
          show: true,
        },
        {
          id: 'eguardia',
          image: Edwin,
          name: 'Edwin Guardia',
          title: 'Master en Derecho Mercantil / Derecho Penal',
          position: 'Socio Adjunto',
          linkedin: 'https://www.linkedin.com/in/edwin-guardia-3b403442/',
          mail: 'eguardia@bgsestudiojuridico.com',
          show: true,
        },
        {
          id: 'aolivella',
          image: Ana,
          name: 'Ana Olivella',
          title: 'Asociado Adjunto',
          position: 'Master en Comercio Internacional',
          linkedin: 'https://www.linkedin.com/in/ana-aurora-olivella-mansilla-22b52873/',
          mail: 'aolivella@bgsestudiojuridico.com',
          show: true,
        },
        // {
        //   id: 'ilee',
        //   image: Profile,
        //   name: 'Irma Lee',
        //   title: 'Asociado Adjunto',
        //   position: '',
        //   linkedin: '',
        //   mail: '',
        //   show: true,
        // },
        {
          id: 'aadames',
          image: Alejandro,
          name: 'Alejandro Adames',
          position: 'Pasante',
          mail: 'info@bgsestudiojuridico.com',
          show: false,
        },
        {
          id: 'acardenas',
          image: Arelys,
          name: 'Arelys Cárdenas',
          position: 'Pasante',
          mail: 'info@bgsestudiojuridico.com',
          show: false,
        },
        {
          id: 'ggallardo',
          image: Gabriela,
          name: 'Gabriela Gallardo',
          position: 'Asistente Administrativa',
          mail: 'info@bgsestudiojuridico.com',
          show: false,
        },
      ],
      allies: [
        {
          image: Claudio,
          brand: Brand,
          name: 'Claudio Paolini',
          position: 'Socio Director',
          specialization: 'Bienes raices',
          mail: 'claudio.paolini@gmail.com',
          linkedin: 'https://www.linkedin.com/in/claudio-paolini-857a4a58/',
        },
        {
          image: Gabriela,
          name: 'Marcia Elena Arosemana',
          position: 'Abogada',
          specialization: 'Contrataciones públicas',
          mail: '',
          linkedin: 'https://www.linkedin.com/in/marcia-a-7569642b/',
        },
      ],
    };
  },
  filters: {
    mailTo(mail) {
      return `mailto:${mail}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-map {
  position: relative;
  width: 100%;
  // margin: auto;
  // -webkit-box-shadow: 0 0 50px -10px #666;
  // box-shadow: 0 0 50px -10px #666;
}

@media screen and (max-width: 600px) {
  .contact-map {
    position: static;
  }
}
</style>
